// eslint-disable-next-line import/no-unresolved
import * as H from 'history';

export type HistoryType = H.History<H.LocationState>;

export let _globalHistory: H.History<H.LocationState>;

export const navigate = (to: number | string) => {
   if (typeof to === "number") {
      _globalHistory.go(to);
   }
   else {
      _globalHistory.push(to);
   }
};

export const globalHistory = (): H.History<H.LocationState> => {
   return _globalHistory;
};

export const initializeGlobalHistory = (history: H.History<H.LocationState>) => {
   _globalHistory = history;
};
